import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import { FightModeSettings, CustomModeSettings } from '@/lib/types/common/GameModeAdvancedSettings';
import InputFFXIV from '../../../InputFFXIV';


const TeamMaxHPSelector: React.FC = () => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSettings, isGameMaster } = useGameModeSettingsContext();

    if (!room || !gameState) return null;

    const value = (settings as FightModeSettings | CustomModeSettings).teamMaxHp ?? 10000;

    const handleTeamMaxHpChange = (newHp: number) => {
        if (isGameMaster) {
            updateSettings({ teamMaxHp: newHp } as Partial<FightModeSettings>);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    return (
        <div className="flex gap-3 items-center">
            <div className="text-[#EEE1C5] text-shadow-border shadow-black text-lg">
                {t('game.config.advancedSettings.teamMaxHp')}
            </div>
            <InputFFXIV
                value={value}
                onChange={(newValue) => handleTeamMaxHpChange(newValue)}
                min={1000}
                max={100000}
                step={1000}
                className="!w-[80px]"
            />
        </div>
    );
};

export default TeamMaxHPSelector;
